<template>
    <img
        src="/img/IconDashboardTemplate.png"
        class="w-full h-full"
        alt="template"
    />
</template>
<script>
    export default {}
</script>
